import React, { Component } from 'react';
import styled from 'styled-components';
import Helmet from 'react-helmet';
import axios from 'axios';

import MessageSection from '../components/MessageSection';
import Notice from '../components/Notice';
import { MenuItem } from '../components/styled';
import StoreSection from './StoreSection';

export default class Signup extends Component {
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);

		this.state = {
			submitted: false,
			isAuthenticated: (localStorage.getItem('id_token') && (localStorage.getItem('userExpires') >= Date.now())) ? true : false,
			newsagencies: [],
		};
	}

	componentDidMount() {
		if (!this.state.isAuthenticated) {
			return window.location.replace(`/agent-login`);
		}
		
		const email = localStorage.getItem('id_email');

		axios.post('/api/account/newsagencies', {
			email,
		}).then(({ data }) => {
			if (!data.success || data.newsagencies && data.newsagencies.length === 0) {
				return this.setState({ errorMessage: 'No newsagencies found.'})
			}

			this.setState({
				newsagencies: data.newsagencies,
			});
		});
	}

	onSubmit(e) {
		e.preventDefault();
	}

	render () {
		return (
			<Container>
				<Helmet
					title="Account"
					meta={[
						{ charset: 'utf-8' },
						{ name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' },
						{ name: 'description', content: 'Signup' },
					]}
					link={[
						{ href: 'https://fonts.googleapis.com/css?family=Roboto+Slab|Karla', rel: 'stylesheet' },
					]}
				/>
				<HeaderContainer>
					<HeaderSection>
						<LogoContainer>
							<a href="/agent"><Image src="/images/redesign/logo.png" /></a>
						</LogoContainer>
						<div>
							<MenuContainer>
								<MenuItem><a href="/agent/faqs">FAQs</a></MenuItem>
							</MenuContainer>
						</div>
					</HeaderSection>
				</HeaderContainer>
				<div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
					<MessageSection
						style={{ marginTop: '50px' }}
						header="Your retail stores"
						paragraph1="Please select which store you are signing the contract for today:"
					/>
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						{this.state.errorMessage ? (
							<Notice
								color="red"
								text={this.state.errorMessage}
							/>
						) : null}
					</div>
					<CenteredContainer>
						<InputContainer>
							{this.state.newsagencies.map((newsagency, key) => (
								<Column key={key}>
									<StoreSection
										name={newsagency.shopName}
										address={newsagency.shopAddress}
										progress={newsagency.progress || 0}
										completeContractToken={newsagency.completeContractToken}
									/>
								</Column>
							))}
							{/* <Column style={{ width: '946px' }}>
								<input type="checkbox" name="isLicensed" defaultValue="isLicensed" label="test" style={{ width: '20px' }} /><span style={{ color: '#505d68' }}>I am a Licensed Post Office (LPO)</span>
							</Column> */}
						</InputContainer>
					</CenteredContainer>
				</div>
			</Container>
		);
	}
};

const InputContainer = styled.div`
	display: flex;
	width: 946px;
	justify-content: space-between;
	margin: 24px;
	flex-wrap: wrap;
`;

const CenteredContainer = styled.div`
	display: flex;
	justify-content: center;
`;

const HeaderContainer = styled.div`
	display: flex;
	justify-content: center;
	border-bottom: 1px solid #dadada;
`;

const HeaderSection = styled.div`
	display: flex;
	width: 946px;
	justify-content: space-between;
	align-items: center;
	height: 50px;
`;

const LogoContainer = styled.div`
	max-width: 120px;
`;

const MenuContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	
`;

const Column = styled.div`
	// width: 465px;
	width: 930px;
	margin-bottom: 20px;
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

const Image = styled.img`
	display: block;
	height: auto;
	width: 100%;
`;



// WEBPACK FOOTER //
// ./client/redesign/web/Account/index.js